module.exports = __webpack_public_path__ + "static/img/logo.c99485b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinDupLeImg/logo.png
// module id = o9FI
// module chunks = 1